import { fmtPct } from "@/lib/format";
import { Check, X } from "lucide-react";

export default function GateCard({ label, subLabel, value, pass, thresholdLabel, testId }) {
  const passed = pass === true;
  const undetermined = value === null || value === undefined;
  return (
    <div
      className="surface p-6 relative overflow-hidden"
      data-testid={testId}
      data-gate-pass={passed ? "true" : "false"}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div
            className="text-[10px] tracking-[0.18em] uppercase font-mono-num"
            style={{ color: "var(--cream-muted)" }}
          >
            Evidence Gate
          </div>
          <div className="mt-2 font-display text-[22px] leading-tight" style={{ color: "var(--cream)" }}>
            {label}
          </div>
          {subLabel && (
            <div className="text-[12px] mt-1" style={{ color: "var(--cream-dim)" }}>
              {subLabel}
            </div>
          )}
        </div>
        <div
          className={`shrink-0 rounded-full px-3 py-1.5 text-[11px] font-mono-num tracking-wider uppercase inline-flex items-center gap-1.5`}
          style={{
            background: undetermined
              ? "var(--surface-3)"
              : passed
              ? "rgba(127,176,105,0.12)"
              : "rgba(217,164,65,0.10)",
            color: undetermined ? "var(--cream-muted)" : passed ? "var(--success)" : "var(--warn)",
            border: `1px solid ${undetermined ? "var(--hairline-strong)" : passed ? "rgba(127,176,105,0.4)" : "rgba(217,164,65,0.35)"}`,
          }}
          data-testid={`${testId}-status`}
        >
          {passed ? <Check className="w-3 h-3" /> : undetermined ? null : <X className="w-3 h-3" />}
          {undetermined ? "Awaiting Data" : passed ? "Pass" : "Not Yet Passing"}
        </div>
      </div>
      <div className="mt-6 flex items-end justify-between">
        <div>
          <div className="kpi gold" data-testid={`${testId}-value`}>
            {fmtPct(value)}
          </div>
          <div className="text-[11px] mt-1" style={{ color: "var(--cream-muted)" }}>
            {thresholdLabel}
          </div>
        </div>
      </div>
    </div>
  );
}
